var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "26",
        height: "19",
        viewBox: "1463.721 300.134 26 19",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M1473.027 319.134a1.93 1.93 0 0 1-1.379-.583l-7.362-7.502a2.027 2.027 0 0 1 0-2.81 1.937 1.937 0 0 1 2.758 0l5.983 6.097 13.37-13.625a1.937 1.937 0 0 1 2.758 0 2.027 2.027 0 0 1 0 2.81l-14.75 15.03a1.93 1.93 0 0 1-1.378.583Z",
          fill: "#92929a",
          "fill-rule": "evenodd",
          "data-name": "Vector",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }